import React from 'react';

import {CheckboxSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const PasswordSharingWarningSkeleton = () => (
    <FormSectionSkeleton labelWidth={185}>
        <Group direction="v">
            <CheckboxSkeleton labelWidth={272}/>
            <SkeletonItem width={100} height={32}/>
        </Group>
    </FormSectionSkeleton>
);
